import { Helpers } from "./Helpers";
export class DataFrame {
    constructor() {
        this.TransactionId = Helpers.GenerateUUID();
    }
}
export var Status;
(function (Status) {
    /// <summary>
    /// Gdy zapytanie się powiodło i nie wystąpiły błędy
    /// </summary>
    Status[Status["OK"] = 0] = "OK";
    /// <summary>
    /// Gdy wystąpił nieznany błąd podczas wykonywania zapytania
    /// </summary>
    Status[Status["UnknownError"] = 1] = "UnknownError";
    /// <summary>
    /// Gdy wystąpił błąd którego oprogramowanie kontrolera nie mogło rozwiązać
    /// </summary>
    Status[Status["FatalError"] = 2] = "FatalError";
    /// <summary>
    /// Gdy zapytanie zostało wykonane z niepoprawnymi danymi
    /// </summary>
    Status[Status["WrongData"] = 3] = "WrongData";
    /// <summary>
    /// Gdy zostało wykonane zapytanie do zasobu który nie istnieje
    /// </summary>
    Status[Status["ResourceDoesNotExists"] = 4] = "ResourceDoesNotExists";
    /// <summary>
    /// Gdy zostało wykonane zapytanie o wykonanie operacji do której zalogowany użytkownik nie ma uprawnień (np. gdy próbuje zmienić dane użytkownika o uprawnieniach wyższych od siebie)
    /// </summary>
    Status[Status["NoPermissionToPerformThisOperation"] = 5] = "NoPermissionToPerformThisOperation";
    /// <summary>
    /// Gdy zostanie dokonana próba ponownego logowania dla już zalogowanej sesji
    /// </summary>
    Status[Status["SessionHasAlreadyLoggedOnUser"] = 6] = "SessionHasAlreadyLoggedOnUser";
    /// <summary>
    /// Gdy żądana operacja jest niedozwolona
    /// </summary>
    Status[Status["OperationNotPermitted"] = 7] = "OperationNotPermitted";
    /// <summary>
    /// Gdy zostanie wykonane zapytanie do zasobu do którego użytkownik nie ma uprawnień
    /// </summary>
    Status[Status["NoPermissionsToCallGivenResource"] = 8] = "NoPermissionsToCallGivenResource";
    /// <summary>
    /// Gdy zostanie wykonane zapytanie do zasobu aktualnie nie dostępnego (gdy np. zasób został wyłączony)
    /// </summary>
    Status[Status["ResourceIsNotAvailable"] = 9] = "ResourceIsNotAvailable";
    /// <summary>
    /// Gdy zapytanie do zasobu zakończyło się okreslonym błędem
    /// </summary>
    Status[Status["Error"] = 10] = "Error";
    /// <summary>
    /// Gdy w ramach odpowiedzi na zapytanie nie są zwracane dane
    /// </summary>
    Status[Status["NoData"] = 11] = "NoData";
    /// <summary>
    /// Gdy zostanie wykonane zapytanie do nie wspieranego zasobu (np. dotyczącego okreslonego systemu operacyjnego)
    /// </summary>
    Status[Status["NotSupportedMethod"] = 12] = "NotSupportedMethod";
    /// <summary>
    /// Gdy zostanie wykonane zapytanie do dowolnego zasobu a żaden użytkownik nie jest zalogowany w ramach sesji
    /// </summary>
    Status[Status["UserIsNotLoggedIn"] = 13] = "UserIsNotLoggedIn";
    /// <summary>
    /// Przewidziane dla zapytań które zwracają wiele odpowiedzi, np. postęp w realizacji jakiegoś procesu
    /// </summary>
    Status[Status["MultiDataResponseStart"] = 14] = "MultiDataResponseStart";
    /// <summary>
    /// Przewidziane dla zapytań które zwracają wiele odpowiedzi, np. postęp w realizacji jakiegoś procesu. Informuje, że dana odpowiedź jest jedną z odpowiedzi
    /// </summary>
    Status[Status["MultiDataResponse"] = 15] = "MultiDataResponse";
    /// <summary>
    /// Przewidziane dla zapytań które zwracają wiele odpowiedzi, np. postęp w realizacji jakiegoś procesu. Informuje, że dana odpowiedź jest ostatnią odpowiedzią danego zasobu
    /// </summary>
    Status[Status["MultiDataResponseStop"] = 16] = "MultiDataResponseStop";
})(Status || (Status = {}));
export var Method;
(function (Method) {
    Method[Method["Get"] = 0] = "Get";
    Method[Method["Post"] = 1] = "Post";
    Method[Method["Delete"] = 2] = "Delete";
    Method[Method["Put"] = 3] = "Put";
    Method[Method["Options"] = 4] = "Options";
    Method[Method["Head"] = 5] = "Head";
})(Method || (Method = {}));
//# sourceMappingURL=DataFrame.js.map